module.exports = __webpack_public_path__ + "static/media/week2week-logo.d35be081.jpg";